import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type SliceSchedulerState = {
  argsCreate?: {
    start?: string;
    end?: string;
  };
  selectedEventId?: string;
};

const initialState: SliceSchedulerState = {};

const slice = createSlice({
  name: "scheduler",
  initialState,
  reducers: {
    setSchedulerArgsCreate: (
      draft,
      action: PayloadAction<SliceSchedulerState["argsCreate"]>,
    ) => {
      draft.argsCreate = action.payload;
    },
    setSchedulerSelectedEventId: (
      draft,
      action: PayloadAction<SliceSchedulerState["selectedEventId"]>,
    ) => {
      draft.selectedEventId = action.payload;
    },
  },
});

export const { setSchedulerArgsCreate, setSchedulerSelectedEventId } =
  slice.actions;

export const reducerScheduler = slice.reducer;
